<template>
  <div class="row mb-2">
    <div class="col-12">
      <h4>{{ $trans.get("__JSON__.Bonus profiles") }}</h4>
    </div>
    <div class="col-12">
      <button class="btn btn-primary float-end" @click="addBonusProfile">
        {{ $trans.get("__JSON__.Add bonus profile") }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <table class="table">
        <thead>
          <tr>
          <th>{{ $trans.get("__JSON__.Name") }}</th>
          <th class="w-10">{{ $trans.get("__JSON__.Actions") }}</th>
          </tr> 
        </thead>
        <tbody>
          <tr v-for="(bonusProfile, index) in bonusProfiles" :key="'bp' + bonusProfile.id">
            <td>{{ bonusProfile.name }}</td>
            <td>
              <button class="btn btn-sm text-primary" @click="edit(index)">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-sm text-primary" @click="deleteBonusProfile(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="bonusprofilemodal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="bonusprofiletitle"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <span v-if="errors['name']">
            <span v-for="error in errors['name']" class="text-danger">
              {{ error }}
            </span>
          </span>

          <div class="mb-3">
            <label for="name">{{ $trans.get("__JSON__.Name") }}</label>
            <input type="text" class="form-control" v-model="editBonusProfile.name" />
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ $trans.get("__JSON__.Close") }}
          </button>
          <button type="button" class="btn btn-primary" @click="save">
            {{ $trans.get("__JSON__.Save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EmployerBonusProfilesonusProfiles",
  created() { },
  props: {
    employer_id: null,
  },
  data() {
    return {
      bonusProfiles: null,
      editBonusProfile: {
        id: null,
        name: null,
        employer_id: this.employer_id,
      },
      errors: [],
    };
  },
  watch: {},
  mounted() {
    this.fetchBonusProfiles();
    console.log("Mounted");
  },
  methods: {
    addBonusProfile() {
      this.editBonusProfile = {
        id: null,
        name: null,
        employer_id: this.employer_id,
      };
      $("#bonusprofiletitle").html(this.$trans.get("__JSON__.Create bonus profile"));
      $("#bonusprofilemodal").modal("show");
    },
    edit(index) {
      console.log(index);
      this.editBonusProfile = this.bonusProfiles[index];
      $("#bonusprofiletitle").html(this.$trans.get("__JSON__.Edit bonus profile"));
      $("#bonusprofilemodal").modal("show");
    },
    deleteBonusProfile(index) {
  if (confirm("Are you sure you want to delete the bonus profile?")) {
    axios
      .delete("/api/employeebonusprofiles/" + this.bonusProfiles[index].id)
      .then((resp) => {
        self.errors = [];
        this.fetchBonusProfiles();
      })
      .catch((error) => {
        this.errors = error.response.data.errors;
      });
  }
},
save() {
  if (this.editBonusProfile.id != null) {
    axios
      .put("/api/employerrate/" + this.editBonusProfile.id, this.editBonusProfile)
      .then((resp) => {
        self.errors = [];
        this.fetchBonusProfiles();
        $("#bonusprofilemodal").modal("hide");
      })
      .catch((error) => {
        this.errors = error.response.data.errors;
      });
  } else {
    axios
      .post("/api/employeebonusprofiles", this.editBonusProfile)
      .then((resp) => {
        self.errors = [];
        this.fetchBonusProfiles();
        $("#bonusprofilemodal").modal("hide");
      })
      .catch((error) => {
        console.log(error.response.data);
        this.errors = error.response.data.errors;
      });
  }
},
fetchBonusProfiles() {
  axios
    .get("/api/employeebonusprofiles", {
      params: {
        employer_id: this.employer_id,
      },
    })
    .then((resp) => {
      this.bonusProfiles = resp.data;
    })
    .catch((error) => {
      console.log(error);
    });
},
  },
};
</script>

<style></style>
